import { render, staticRenderFns } from "./RegistrationStatus.vue?vue&type=template&id=706607ac&scoped=true"
import script from "./RegistrationStatus.vue?vue&type=script&lang=js"
export * from "./RegistrationStatus.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStatus.vue?vue&type=style&index=0&id=706607ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706607ac",
  null
  
)

export default component.exports